<script setup>
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { usePipelinesStore } from 'dashboard/stores/pipelines';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import TwoColumnDetailLayout from 'dashboard/components-next/TwoColumnDetailLayout.vue';
import DealCreateSidebar from 'dashboard/components-next/Deals/DealDetail/DealCreateSidebar.vue';

// Pagina de criacao: mesmo layout da pagina da Negociacao, com o formulario
// de criacao na coluna esquerda. Criada, vai para a pagina dedicada dela.
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const pipelinesStore = usePipelinesStore();

const numberQuery = key => Number(route.query[key]) || null;

const initialValues = computed(() => ({
  pipelineStageId: numberQuery('stage_id'),
  contactId: numberQuery('contact_id'),
  companyId: numberQuery('company_id'),
}));

onMounted(() => {
  if (!pipelinesStore.getPipelinesList.length) pipelinesStore.get();
});

const goBack = () => {
  if (window.history.state?.back) {
    router.back();
    return;
  }
  router.push({
    name: 'deals_all',
    params: { accountId: route.params.accountId },
  });
};

const handleCreated = deal => {
  router.replace({
    name: 'deals_edit',
    params: { accountId: route.params.accountId, dealId: deal.id },
  });
};
</script>

<template>
  <TwoColumnDetailLayout
    has-data
    :storage-key="LOCAL_STORAGE_KEYS.DEAL_DETAIL_SIDEBAR_WIDTH"
  >
    <template #sidebar>
      <DealCreateSidebar
        :initial-values="initialValues"
        :default-pipeline-id="numberQuery('pipeline_id')"
        :conversation-id="numberQuery('conversation_id')"
        @back="goBack"
        @created="handleCreated"
      />
    </template>
    <template #timeline>
      <div
        class="flex items-center justify-center w-full h-full px-6 text-sm text-center text-n-slate-11"
      >
        {{ t('DEALS.CREATE.TIMELINE_PLACEHOLDER') }}
      </div>
    </template>
  </TwoColumnDetailLayout>
</template>
